import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

export const SelectInput = (props) => {
  const { description = "", label, options = [] } = props;

  return (
    <FormControl>
      {label ? <InputLabel>{label}</InputLabel> : null}
      <Select {...props}>
        {options.map(({ label, value }) => {
          return <MenuItem value={value}>{label}</MenuItem>;
        })}
      </Select>
      {description ? (
        <Typography variant="small" style={{ fontSize: "10px" }}>
          {description}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export default SelectInput;
